module.exports = __webpack_public_path__ + "static/img/bg_wrap.badc61eb.png";